import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ProductAlias } from '@ibk/shared-types';
import { Carousel } from '../Carousel';
import { useContaPjEmpresaBanners, useContaPjEscritorioBanners, useHomeProductBanners } from './hooks';
import styles from './ProductBannersCarousel.module.css';
export const ProductBannersCarousel = ({ context, productsData, autoPlay = true, interval = 5000, className, 'data-testid': dataTestId, }) => {
    const defaultProductsData = {
        products: {
            [ProductAlias.CONTA_DIGITAL]: { data: null, isLoading: false, error: null },
            [ProductAlias.COBRANCAS]: { data: null, isLoading: false, error: null },
            [ProductAlias.BENEFICIOS]: { data: null, isLoading: false, error: null },
            [ProductAlias.CONTABILIDADE_DIGITAL]: { data: null, isLoading: false, error: null },
            [ProductAlias.DOMINIO_RECOMPENSAS]: { data: null, isLoading: false, error: null },
        },
        isLoading: false,
        hasError: false,
    };
    const isContaPjContext = context.type === 'conta-pj';
    const isHomeContext = context.type === 'home';
    const isEscritorioContext = isContaPjContext && context.domain === 'escritorio';
    const isEmpresaContext = isContaPjContext && context.domain === 'empresa';
    const isHomeEmpresaContext = isHomeContext && context.domain === 'empresa';
    const contaPjEscritorioBanners = useContaPjEscritorioBanners({
        productsData: productsData ?? defaultProductsData,
        isActive: isEscritorioContext ? (context.isActive ?? true) : false,
    });
    const contaPjEmpresaBanners = useContaPjEmpresaBanners({
        productsData: productsData ?? defaultProductsData,
        isActive: isEmpresaContext ? (context.isActive ?? true) : false,
        hasBillingPermission: context.permissions?.hasBillingPermission,
        isBillingProductAvailable: context.permissions?.isBillingProductAvailable,
    });
    const homeProductBanners = useHomeProductBanners({
        productsData: productsData ?? defaultProductsData,
        domain: context.domain ?? 'empresa',
        isActive: isHomeEmpresaContext ? (context.isActive ?? true) : false,
        hasBillingPermission: context.permissions?.hasBillingPermission,
        isBillingProductAvailable: context.permissions?.isBillingProductAvailable,
        includeHappyHolidaysBanner: context.includeHappyHolidaysBanner ?? false,
    });
    const banners = React.useMemo(() => {
        switch (context.type) {
            case 'conta-pj':
                if (!productsData)
                    return [];
                if (context.domain === 'empresa') {
                    return contaPjEmpresaBanners;
                }
                return contaPjEscritorioBanners;
            case 'home':
                if (!productsData)
                    return [];
                return homeProductBanners;
            case 'beneficios':
                return [];
            case 'pagamentos':
                return [];
            case 'contabilidade-digital':
                return [];
            case 'custom':
                return context.customBanners ?? [];
            default:
                return [];
        }
    }, [context, productsData, contaPjEscritorioBanners, contaPjEmpresaBanners, homeProductBanners]);
    if (!banners?.length) {
        return null;
    }
    return (_jsx("div", { className: `${styles.container} ${className ?? ''}`, "data-testid": dataTestId, children: _jsx(Carousel, { items: banners, autoPlay: autoPlay, interval: interval, "data-testid": `${dataTestId}-carousel` }) }));
};
